import type { FormatDef, FormatId } from '@/types';

export const FORMATS: Record<FormatId, FormatDef> = {
  'ig-portrait': {
    id: 'ig-portrait',
    label: 'Instagram Portrait',
    short: '4:5',
    width: 1080,
    height: 1350,
    safe: { top: 0.05, bottom: 0.05, left: 0.055, right: 0.055 },
  },
  'ig-square': {
    id: 'ig-square',
    label: 'Instagram Square',
    short: '1:1',
    width: 1080,
    height: 1080,
    safe: { top: 0.06, bottom: 0.06, left: 0.06, right: 0.06 },
  },
  'ig-story': {
    id: 'ig-story',
    label: 'Story / Reel',
    short: '9:16',
    width: 1080,
    height: 1920,
    // Stories lose ~250px to the header and ~350px to the caption/CTA rail.
    safe: { top: 0.13, bottom: 0.18, left: 0.055, right: 0.055 },
  },
  'fb-post': {
    id: 'fb-post',
    label: 'Facebook Post',
    short: '1.91:1',
    width: 1200,
    height: 630,
    safe: { top: 0.07, bottom: 0.07, left: 0.05, right: 0.05 },
  },
  'li-post': {
    id: 'li-post',
    label: 'LinkedIn Post',
    short: '1.91:1',
    width: 1200,
    height: 627,
    safe: { top: 0.07, bottom: 0.07, left: 0.05, right: 0.05 },
  },
};

export const FORMAT_LIST = Object.values(FORMATS);

export function getFormat(id: FormatId): FormatDef {
  return FORMATS[id] ?? FORMATS['ig-portrait'];
}
